import Card from "@/components/common/Card";
import FormField from "@/components/common/FormField";
import MainHeading from "@/components/common/MainHeading";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import type { CreateOdPayload } from "@/interface/od.interface";
import { OdService } from "@/services/Od/OdService";
// import { OdService, type CreateOdPayload } from "@/services/Od/OdService";
import { showToastNotification } from "@/utility/helper";
import { RoutesLink } from "@/utility/RouteLinks";
import { errorTypes } from "@/utility/validation";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const CreateOd: React.FC = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<CreateOdPayload
        & { purpose: string }>();

    const onSubmit = async (data: any) => {
        const payload: CreateOdPayload = {
            date: data.date,
            reason: data.purpose,
            location: data.location,
            expectedReturnTime: data.expectedReturnTime,
        };

        try {
            setIsLoading(true);
            await OdService.create(payload);
            showToastNotification("success", "OD applied successfully");
            //   navigate(-1);
            navigate(RoutesLink.myOd || (-1 as any));
        } catch (error: any) {
            console.error("Create OD error:", error);
            showToastNotification("danger", error?.message || "Failed to apply OD");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading
                    title="Apply for OD"
                    isBackButtonVisible
                    onClick={() => navigate(-1)}
                />
                <Card className="overflow-visible">
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("date", { ...errorTypes.required("Date") })}
                                type="date"
                                label="Date"
                                error={errors.date?.message as string}
                            />

                            <FormField
                                {...register("location", {
                                    ...errorTypes.required("Location"),
                                })}
                                type="text"
                                label="Location"
                                placeholder="Enter location"
                                error={errors.location?.message as string}
                            />

                            <FormField
                                {...register("purpose", { ...errorTypes.required("Purpose") })}
                                type="text"
                                label="Purpose"
                                placeholder="Enter purpose for OD"
                                error={errors.purpose?.message as string}
                            />

                            {/* New field added : Expected Return Time */}
                            <FormField
                                {...register("expectedReturnTime", {
                                    ...errorTypes.required("Expected Return Time"),
                                })}
                                type="time"
                                label="Expected Return Time"
                                placeholder="e.g., 18:30"
                                error={errors.expectedReturnTime?.message as string}
                            />
                        </div>

                        <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-100">
                            <Button
                                type="button"
                                variant="outline"
                                onClick={() => navigate(-1)}
                                disabled={isLoading}
                            >
                                Cancel
                            </Button>
                            <Button type="submit" disabled={isLoading}>
                                {isLoading ? "Submitting..." : "Apply OD"}
                            </Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>
    );
};

export default CreateOd;
